const ST4_odds = [
  {
    product1: "A",
    d_level: "option1",
    product: "J",
  },
  {
    product1: "A",
    d_level: "option2",
    product: "J",
  },
  {
    product1: "A",
    d_level: "option3",
    product: "K",
  },
  {
    product1: "B",
    d_level: "option1",
    product: "J",
  },
  {
    product1: "B",
    d_level: "option2",
    product: "K",
  },
  {
    product1: "B",
    d_level: "option3",
    product: "L",
  },
  {
    product1: "C",
    d_level: "option1",
    product: "K",
  },
  {
    product1: "C",
    d_level: "option2",
    product: "L",
  },
  {
    product1: "C",
    d_level: "option3",
    product: "M",
  },
  {
    product1: "D",
    d_level: "option1",
    product: "L",
  },
  {
    product1: "D",
    d_level: "option2",
    product: "M",
  },
  {
    product1: "D",
    d_level: "option3",
    product: "M",
  },
];
export default ST4_odds;
